import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import PDPInfoTable from '../PDPInfoTable';
import PDPDimensionsImage from './PDPDimensionsImage';
import PDPShippingDimensionsPlaceholder from '../PDPShippingDimensionsPlaceholder';
const PDPDimensionsContentUI = t0 => {
  const $ = _c(34);
  const {
    dimensionsDesktopImage,
    dimensionsMobileImage,
    dimensions: t1,
    boxDimensions: t2,
    boxDimensionsPending: t3,
    loading: t4,
    onImageClick,
    isSidebarContent: t5,
    hasCylindoDimensionShots: t6,
    dimensionShotUrls: t7,
    currentDimensionShot,
    selectedDimensionShotIndex: t8,
    setSelectedDimensionShotIndex
  } = t0;
  let t9;
  if ($[0] !== t1) {
    t9 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  const dimensions = t9;
  let t10;
  if ($[2] !== t2) {
    t10 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  const boxDimensions = t10;
  const boxDimensionsPending = t3 === undefined ? false : t3;
  const loading = t4 === undefined ? false : t4;
  const isSidebarContent = t5 === undefined ? false : t5;
  const hasCylindoDimensionShots = t6 === undefined ? false : t6;
  let t11;
  if ($[4] !== t7) {
    t11 = t7 === undefined ? [] : t7;
    $[4] = t7;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  const dimensionShotUrls = t11;
  const selectedDimensionShotIndex = t8 === undefined ? 0 : t8;
  let t12;
  if ($[6] !== loading) {
    t12 = loading && <Placeholder loading={true} type="rect" style={{
      marginRight: 0,
      marginTop: "10px",
      height: "207px"
    }} />;
    $[6] = loading;
    $[7] = t12;
  } else {
    t12 = $[7];
  }
  let t13;
  if ($[8] !== currentDimensionShot || $[9] !== dimensionShotUrls || $[10] !== dimensionsDesktopImage || $[11] !== dimensionsMobileImage || $[12] !== hasCylindoDimensionShots || $[13] !== isSidebarContent || $[14] !== loading || $[15] !== onImageClick || $[16] !== selectedDimensionShotIndex || $[17] !== setSelectedDimensionShotIndex) {
    t13 = !loading && <PDPDimensionsImage dimensionsDesktopImage={dimensionsDesktopImage} dimensionsMobileImage={dimensionsMobileImage} onImageClick={onImageClick} isSidebarContent={isSidebarContent} hasCylindoDimensionShots={hasCylindoDimensionShots} dimensionShotUrls={dimensionShotUrls} currentDimensionShot={currentDimensionShot} selectedDimensionShotIndex={selectedDimensionShotIndex} setSelectedDimensionShotIndex={setSelectedDimensionShotIndex} />;
    $[8] = currentDimensionShot;
    $[9] = dimensionShotUrls;
    $[10] = dimensionsDesktopImage;
    $[11] = dimensionsMobileImage;
    $[12] = hasCylindoDimensionShots;
    $[13] = isSidebarContent;
    $[14] = loading;
    $[15] = onImageClick;
    $[16] = selectedDimensionShotIndex;
    $[17] = setSelectedDimensionShotIndex;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== dimensions || $[20] !== loading) {
    t14 = <div className="max-w-[480px] mx-auto my-0"><PDPInfoTable items={dimensions} loading={loading} /></div>;
    $[19] = dimensions;
    $[20] = loading;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== boxDimensionsPending) {
    t15 = boxDimensionsPending && <PDPShippingDimensionsPlaceholder />;
    $[22] = boxDimensionsPending;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== boxDimensions || $[25] !== boxDimensionsPending || $[26] !== loading) {
    t16 = !boxDimensionsPending && boxDimensions?.length > 0 && <div className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14"><div className="max-w-[480px] mx-auto my-0"><h2 className="text-xl font-bold text-gray">{loading ? <Placeholder type="rect" loading={true} style={{
            height: "28px",
            width: "220px"
          }} /> : "Shipping Dimensions"}</h2></div><div className="max-w-[480px] mx-auto my-0"><PDPInfoTable items={boxDimensions} loading={loading} /></div></div>;
    $[24] = boxDimensions;
    $[25] = boxDimensionsPending;
    $[26] = loading;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t12 || $[29] !== t13 || $[30] !== t14 || $[31] !== t15 || $[32] !== t16) {
    t17 = <div className="PDPDimensionsContentUI">{t12}{t13}{t14}{t15}{t16}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
};
PDPDimensionsContentUI.propTypes = {
  dimensions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  boxDimensions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  boxDimensionsPending: PropTypes.bool,
  dimensionsDesktopImage: PropTypes.string,
  dimensionsMobileImage: PropTypes.string,
  loading: PropTypes.bool,
  isSidebarContent: PropTypes.bool,
  onImageClick: PropTypes.func,
  hasCylindoDimensionShots: PropTypes.bool,
  dimensionShotUrls: PropTypes.arrayOf(PropTypes.object),
  currentDimensionShot: PropTypes.shape({
    src: PropTypes.string.isRequired,
    dimensionCode: PropTypes.string.isRequired
  }),
  selectedDimensionShotIndex: PropTypes.number,
  setSelectedDimensionShotIndex: PropTypes.func
};
export default PDPDimensionsContentUI;